import { usePriceChangeMarketReactionData } from '@terminal/hooks/use-price-change-market-reaction-data/usePriceChangeMarketReactionData';
import { usePriceMarketReactionData } from '@terminal/hooks/use-price-market-reaction-data/usePriceMarketReactionData';
import { useEntities } from '@terminal/react-query-hooks/entities/useEntities';

import { MarketCatalystReactionChartData } from '../market-catalyst-reaction.types';

type UseMultipleEtfMarketReactionLinesArgs = {
  tags: string[];
  tickers: string[];
  createdAt: string;
};

export const useMultipleEtfMarketReactionLines = ({
  tags,
  tickers,
  createdAt,
}: UseMultipleEtfMarketReactionLinesArgs): MarketCatalystReactionChartData => {
  const {
    fromDateEST,
    toDateEST,
    isLoading: isPriceMarketReactionDataLoading,
  } = usePriceMarketReactionData({
    entityTag: tags[0],
    ticker: tickers[0],
    reportingDate: createdAt,
    isMultipleEntitiesChart: true,
    variant: 'catalyst',
    isMarketCatalyst: true,
  });

  const { data: entitiesData } = useEntities({
    entityTags: tags,
  });

  const {
    data: priceChangeData,
    isLoading: isPriceChangeMarketReactionDataLoading,
  } = usePriceChangeMarketReactionData({
    tags,
    tickers,
    fromDateEST,
    toDateEST,
    enabled: true,
  });

  return {
    lines: priceChangeData,
    fromDateEST,
    toDateEST,
    isLoading:
      isPriceMarketReactionDataLoading ||
      isPriceChangeMarketReactionDataLoading,
    entities: entitiesData,
  };
};
